import React from "react";
import "./App.css";
import logo from "./logo.jpeg";
import Main from "./main";
function App() {
  return (
    <div>
      <header className="header">
        <div style={{ width: "50%" }}>
          <img src={logo} alt="ICMR - NIE" width="20%" />
        </div>
        {window.location.pathname === "/cohort" ? (
          <div
            className="navigation"
            style={{ width: "50%", textAlign: "right" }}
            onClick={() => window.location.replace("/")}
          >
            <span>I-MUCOR for ICMR - NIE</span> <kbd>v0.3</kbd>
          </div>
        ) : (
          <div
            className="navigation"
            style={{ width: "50%", textAlign: "right" }}
            onClick={() => window.location.replace("/cohort")}
          >
            I-MUCOR (Cohort) for ICMR - NIE <kbd>v0.3</kbd>
          </div>
        )}
      </header>
      <main>
        <Main />
      </main>
    </div>
  );
}

export default App;
